import i18n from 'i18next';
// FUTURE READERS: also look in config.{env}.json for ENABLED_USER_ROLE_SCOPES, you have to whitelist each one individually. you're welcome.
export const scopeToLabelText = (scopeGroupCode: string) =>
  ({
    dash: i18n.t('Dashboards'),
    dashAlarm: i18n.t('Alarms dashboard'),
    dashActivity: i18n.t('Activity dashboard'),
    dashEntry: i18n.t('Entry dashboard'),
    dashCust: i18n.t('Custom dashboard'),
    map: i18n.t('Maps'),
    user: i18n.t('Users'),
    role: i18n.t('Roles'),
    site: i18n.t('Sites'),
    ldp: i18n.t('Lockdown plans'),
    rpt: i18n.t('Reports'),
    hw: i18n.t('Devices'),
    admin: i18n.t('Administration'),
    's-o': i18n.t('Sub-organizations'),
    's-o-video': i18n.t('Sub-organizations video'),
    i: 'Identities',
    o: i18n.t('Organizations'),
    'o-support': i18n.t('Org info for customer support'),
    'o-basic': i18n.t('Basic org account info'),
    'o-acu': i18n.t('Basic device and site/zone/entry configuration'),
    'o-completeHookAction': i18n.t('Complete hook actions'),
    pc: i18n.t('Physical credentials'),
    credential: i18n.t('Credentials'),
    siteGeneral: i18n.t('All other site items'),
    entryState: i18n.t('Entry states'),
    rptAlarm: i18n.t('Alarm report'),
    rptDownload: i18n.t('Report download'),
    rptGeneral: i18n.t('All other report items'),
    entryAccessAudit: i18n.t('Entry access audit'),
    portalAudit: i18n.t('Portal audit report'),
    integrations: i18n.t('App marketplace'),
    outboundWebhooks: i18n.t('Rules'),
    account: i18n.t('Account'),
    mobileAppSettings: i18n.t('Mobile app settings'),
    musterReport: i18n.t('Muster report'),
    occupancyReport: i18n.t('Occupancy report'),
    alertSettings: i18n.t('Alerts'),
    quickStart: i18n.t('Quick start page'),
    configurations: i18n.t('Configurations'),
    alarmActions: i18n.t('Alarm actions'),
    alarmConfigurations: i18n.t('Alarm'),
    presence: i18n.t('Presence'),
    erpParentCenter: i18n.t('Partner billing site'),
    erpParentStore: i18n.t('Partner device store'),
    opvideoDevice: i18n.t('Openpath video device'),
    videoProviderLive: i18n.t('View live feed'),
    videoProviderPlayback: i18n.t('Playback video clips'),
    building: i18n.t('Buildings'),
    badgePrinting: i18n.t('Badge printing'),
    exportClips: i18n.t('Export video clips'),
    opvideoIntercomStartSession: i18n.t('Initialize intercom session'),
    opvideoIntercom: i18n.t('Openpath video intercom'),
    parcelMgmtParcels: i18n.t('Mailroom'),
    serviceCancellation: i18n.t('Cancel service'),
    cobalt: i18n.t('Assist Chat'),
    sos: i18n.t('SOS'),
    visitorAdmin: i18n.t('Administration'),
    visitorIntegration: i18n.t('Integrations'),
    visitorConfigurations: i18n.t('Configurations'),
    visitorAlertSettings: i18n.t('Notifications'),
    visitorLocation: i18n.t('Locations'),
    visitorUser: i18n.t('Users'),
    visitorInvitation: i18n.t('Invitation'),
    visitorSigninConf: i18n.t('Sign In'),
    visitorSignoutConf: i18n.t('Sign Out'),
    visitorKiosk: i18n.t('Kiosk'),
    visitorAgreements: i18n.t('Agreements'),
    visitorRedflagConf: i18n.t('Red Flag'),
    visitorFields: i18n.t('Custom Fields'),
    visitorEmailTemplates: i18n.t('Email Templates'),
    visitorDash: i18n.t('Dashboard'),
    visitorVisitors: i18n.t('Visitor'),
    visitorInvite: i18n.t('Invitation'),
    visitorAllVisitors: i18n.t('All Visitors'),
    visitorVisitorLog: i18n.t('Visitor Log'),
    visitorSignIn: i18n.t('Sign In'),
    visitorSignOut: i18n.t('Sign Out'),
    visitorDeny: i18n.t('Deny'),
    visitorRedFlag: i18n.t('Red Flag'),
    visitorGuestPass: i18n.t('Guest Pass'),
    visitorVisitorsBulk: i18n.t('Bulk Visitors'),
    visitorRpt: i18n.t('Reports'),
    visitorRptVisitor: i18n.t('Visitor Report'),
    visitorRptTrend: i18n.t('Repeat Report'),
    visitorRptRedFlag: i18n.t('Red Flag'),
    visitorRptHost: i18n.t('Host Report'),
    visitorRptActivity: i18n.t('Activity Report'),
    visitorRptGuestPass: i18n.t('Guest Pass'),
  })[scopeGroupCode];
